<template>
  <v-main>
    <v-fade-transition mode="out-in">
      <router-view />
    </v-fade-transition>
      <div class="text-center">
    <v-bottom-sheet
      v-model="sheet"
      persistent
    >
      <v-sheet
        class="text-center"
        height="3%"
      >
        <div class="py-3">
          This website uses cookies and the following services: Google Fonts, Google Analytics, FontAwesome and JSDelivr to guarantee the best web experience for you.
        </div>
        <v-btn
          text
          dark
          color="primary"
          @click="accept()"
        >
          accept
        </v-btn>
      </v-sheet>
    </v-bottom-sheet>
  </div>
  </v-main>
</template>

<script>
  export default {
    name: 'BaseView',
    data: () => ({
      sheet: true,
    }),
    mounted () {
      if (this.getCookie("accepted") === "") {
        this.sheet = true
      } else {
        this.sheet = false
      }
    },
    methods: {
      getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) === ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      },
      accept() {
        document.cookie = "accepted= 1; expires=Mon, 27 May 2024 12:00:00 UTC;"
        this.sheet = false
      },
    },
  }
</script>
